// Utility to get the most recent valid enrollment for the user's default access card
export function getValidEnrollment(userData) {
  if (!userData || !userData.accesscards || !userData.default_accesscard_id) return null;
  const card = userData.accesscards.find(ac => ac.accesscard_id === userData.default_accesscard_id);
  if (!card || !Array.isArray(card.enrollments)) return null;
  const today = new Date();
  const valid = card.enrollments.filter(e => {
    if (!e.start_date) return false;
    const start = new Date(e.start_date);
    if (!e.end_date) return start <= today;
    const end = new Date(e.end_date);
    return start <= today && today <= end;
  });
  if (valid.length === 0) return null;
  return valid.reduce((latest, curr) => new Date(curr.start_date) > new Date(latest.start_date) ? curr : latest, valid[0]);
} 